import { useEffect } from 'react'

import { useBootstrapLoadingStore } from 'components/bootstrap-loader/store'

/**
 * Register a named loading flag into the global bootstrap registry.
 * The overlay stays visible as long as any registered flag is true.
 * Auto-clears this key on unmount so no stale flags linger.
 */
export const useRegisterBootstrapLoading = (
  key: string,
  isActive: boolean,
): void => {
  const setLoading = useBootstrapLoadingStore((s) => s.setLoading)

  useEffect(() => {
    setLoading(key, isActive)
  }, [key, isActive, setLoading])

  // Clean up this key when the gate component unmounts
  useEffect(
    () => () => {
      setLoading(key, false)
    },
    [key, setLoading],
  )
}

/**
 * Returns true if any registered bootstrap gate is currently loading.
 * Used by GlobalBootstrapOverlay to toggle visibility.
 */
export const useIsBootstrapLoading = (): boolean =>
  useBootstrapLoadingStore((s) => Object.values(s.active).some(Boolean))
